import { useEffect } from "react";

export const useRemoveClickedStyle = () => {
    useEffect(() => {
        const clickWindow = (e: Event) => {
            const clickTarget = e.target as HTMLElement;
            if (!clickTarget.closest(".rt_cell") && !clickTarget.closest(".rt_shiftCode")) {
                document.querySelectorAll(".clicked").forEach((el) => el.classList.remove("clicked"));
            }
        };
        window.addEventListener("click", clickWindow);
        return () => {
            window.removeEventListener("click", clickWindow);
        };
    }, []);
};
